import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, Table } from 'reactstrap';
import withLoader from 'components/organisms/withLoader';
import ResetPasswordModal from 'components/organisms/resetPassword';
import DoctorRow from './components/doctorRow';
import DoctorsToolbar from './components/toolbar';
import DoctorsHeader from './components/header';
import DoctorsFooter from './components/footer';

const AdminPanelUsers = () => {
  const [email, setEmail] = useState(null);
  const [resetPasswordPopupOpen, setResetPasswordPopupOpen] = useState(false);
  const { data } = useSelector((state) => state.adminPanelUsers);
  const { getUsers: usersLoading } = useSelector(
    (state) => state.loading.effects.adminPanelUsers,
  );
  return (
    <div className="adminPanel">
      <Card className="card-border">
        <CardBody className="card-outer">
          <DoctorsHeader />
          <DoctorsToolbar />
          <div className="adminPanel__table">
            {withLoader(
              usersLoading,
              <Table bordered cellSpacing="0">
                <thead>
                  <tr>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Full Name
                      </div>
                    </th>

                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Role
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Clinic
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Email
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Reset Email
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Status
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((doctorRow, index) => (
                    <DoctorRow
                      key={`${doctorRow.id}-${index}`}
                      data={doctorRow}
                      selectEmail={() => {
                        setEmail(doctorRow.email);
                        setResetPasswordPopupOpen(true);
                      }}
                    />
                  ))}
                </tbody>
              </Table>,
            )}
          </div>
          <DoctorsFooter />
        </CardBody>
      </Card>
      <ResetPasswordModal
        isOpen={resetPasswordPopupOpen}
        toggle={setResetPasswordPopupOpen}
        email={email}
      />
    </div>
  );
};

export default AdminPanelUsers;
